import { LegacyGatewayBase } from './base'
import { toBeaconProps } from './translator/beacon'
import { toOptionsProps } from './translator/options'
import { GetBeacon, GetBeacons } from '@/infrastructure/network/Legacy/requests/beacon'
import { EmptyOptionsPropsFactory, IParamsProps } from '@/entities/Legacy/Options'

export default class Beacon extends LegacyGatewayBase {
  async GetBeacon(hospitalId: string, id: string) {
    const { beacon } = await this.apiClient.request(new GetBeacon(hospitalId, id))
    return beacon ? toBeaconProps(beacon) : null
  }

  async GetBeacons(hospitalId: string, props: IParamsProps) {
    const { beacons, options } = await this.apiClient.request(new GetBeacons(hospitalId, props))
    const params = {
      items: beacons ? beacons.map((prop) => toBeaconProps(prop)) : [],
      options: options ? toOptionsProps(options) : EmptyOptionsPropsFactory()
    }
    return params
  }
}
